import { createEffect, createEvent, forward } from "effector";
import { login as makeLoginRequest, authApi, sessionTimeout, } from "frontend/src/api/auth";
import { notify } from "frontend/src/features/notifications";
import { viewerReset } from "../../domain/session";
export var login = createEvent();
export var logout = createEvent();
export var register = createEvent();
export var loginFx = createEffect(makeLoginRequest);
var logoutFx = createEffect(authApi.logout);
forward({
    from: login,
    to: loginFx,
});
forward({
    from: logout,
    to: logoutFx,
});
forward({
    from: sessionTimeout,
    to: logoutFx,
});
forward({
    from: logout,
    to: viewerReset,
});
forward({
    from: sessionTimeout,
    to: notify.prepend(function () { return ({
        variant: "warning",
        message: "Сессия истекла.",
    }); }),
});
